import { useLayoutEffect, useState } from 'react';

export type ThemeMode = 'light' | 'dark';

export function useThemeMode(): [ThemeMode, (mode: ThemeMode) => void] {
  const [themeMode, setThemeMode] = useState<ThemeMode>('light');

  useLayoutEffect(() => {
    document.documentElement.setAttribute('theme', themeMode);
  }, [themeMode]);

  useLayoutEffect(() => {
    const preferredColor = window.matchMedia('(prefers-color-scheme: dark)');

    const handleChange = (event: MediaQueryListEvent | MediaQueryList) => {
      setThemeMode(event.matches ? 'dark' : 'light');
    };

    handleChange(preferredColor);
    preferredColor.addEventListener('change', handleChange);

    return () => {
      preferredColor.removeEventListener('change', handleChange);
    };
  }, []);

  return [themeMode, setThemeMode];
}
